import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import RoxCreditsSlide from './RoxCreditsSlide';
import RoxFreeEntrySlide from './RoxFreeEntrySlide';
import RoxRewardsSlide from './RoxRewardsSlide';
import RoxWelcomeSlide from './RoxWelcomeSlide';
import styles from "../../static/styles/RoxESL/RoxLanding.module.css";
import crossIcon from '../../static/img/RoxESL/CloseSign.svg';
import { onboardRoxUser } from '../../api/rox';
import { normalizeMsisdn } from '../../utils/msisdn';

const slides = [
    { key: 'welcome', component: <RoxWelcomeSlide /> },
    { key: 'credits', component: <RoxCreditsSlide /> },
    { key: 'free-entry', component: <RoxFreeEntrySlide /> },
    { key: 'rewards', component: <RoxRewardsSlide /> },
];

const ctaLabels = [
    'SHOW ME AROUND',
    'GOT IT - NEXT',
    'AWESOME - NEXT',
    'CLAIM & CONTINUE',
];

const RoxLanding = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const swiperRef = useRef(null);
    const [activeSlide, setActiveSlide] = useState(0);

    useEffect(() => {
        const msisdn = normalizeMsisdn(searchParams.get('a'));
        const rox = searchParams.get('rox');
        const paramsToStrip = ['a', 'rox'].filter((key) => searchParams.has(key));

        if (msisdn && rox === '1') {
            onboardRoxUser(msisdn);
        }

        if (paramsToStrip.length) {
            const cleanedParams = new URLSearchParams(window.location.search);
            paramsToStrip.forEach((key) => cleanedParams.delete(key));
            navigate({ pathname: location.pathname, search: cleanedParams.toString() }, { replace: true });
        }
    }, [searchParams]);

    const containerClassName = [
        styles.container,
        activeSlide === 1 ? styles.containerCredits : '',
        activeSlide === 2 ? styles.containerBonus : '',
        activeSlide === 3 ? styles.containerRewards : '',
    ].filter(Boolean).join(' ');

    const handleCtaClick = () => {
        if (activeSlide >= slides.length - 1) {
            navigate('/');
            return;
        }

        swiperRef.current?.slideNext();
    };

    return (
        <div className={containerClassName}>
            <div className={styles.topBar}>
                <img src={crossIcon} alt="" onClick={() => navigate('/')} />
                <span className={styles.topBarESL}>ESL</span>
                <span className={styles.topBarSkip} onClick={() => navigate('/')}>skip</span>
            </div>

            <Swiper
                modules={[Pagination]}
                pagination={{ clickable: true }}
                slidesPerView={1}
                spaceBetween={0}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                onSlideChange={(swiper) => setActiveSlide(swiper.activeIndex)}
                className={styles.RoxSwiper}
            >
                {slides.map((slide) => (
                    <SwiperSlide key={slide.key}>
                        <div className={styles.RoxSlideFrame}>
                            {slide.component}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <button className={styles.RoxTourButton} type="button" onClick={handleCtaClick}>
                {ctaLabels[activeSlide]} <span aria-hidden="true">-&gt;</span>
            </button>
        </div>
    );
};

export default RoxLanding;
